import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import useFeatureFlagStore from '~/domain/shared/feature-flag/stores/useFeatureFlagStore'
import {
  isLojaInterestRoute,
  isOnlineStoreMenuEnabled,
  isOnlineStoreRoute,
  resolveOnlineStoreDestination
} from '~/domain/shared/navigation/composables/isOnlineStoreMenuEnabled'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!isOnlineStoreRoute(to.path) && !isLojaInterestRoute(to.path)) {
    return
  }

  const authStore = useAuthenticationStore()
  if (!authStore.logged || authStore.companies?.[0]?.id == null) {
    return
  }

  const featureFlagStore = useFeatureFlagStore()
  await featureFlagStore.fetch()

  if (!featureFlagStore.fetched) {
    return
  }

  const destination = resolveOnlineStoreDestination(to.path, isOnlineStoreMenuEnabled())
  if (destination == null) {
    return
  }

  return navigateTo(destination)
})
